import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import RatingBadge from "./RatingBadge";
import { formatDate, typeLabel } from "@/lib/movies";

interface MovieCardProps {
  movie: Movie;
  variant?: "grid" | "compact";
  showRating?: boolean;
  showActors?: boolean;
}

export default function MovieCard({
  movie,
  variant = "grid",
  showRating = true,
  showActors = false,
}: MovieCardProps) {
  const compact = variant === "compact";
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group block cursor-pointer"
      title={`${movie.title} - 天天影院影视详情`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 天天影院影视详情`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/0 to-foreground-950/0 opacity-70" />
        <div className="absolute top-2 left-2">
          <span className="rounded-md bg-primary-500/90 text-background-50 text-[11px] px-1.5 py-0.5">
            {typeLabel(movie.type)}
          </span>
        </div>
        {showRating && (
          <div className="absolute top-2 right-2">
            <RatingBadge rating={movie.rating} size="sm" />
          </div>
        )}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-11 h-11 rounded-full bg-background-50/90 text-primary-600 flex items-center justify-center text-xl">
            <i className="ri-play-fill" />
          </span>
        </div>
      </div>
      <div className={compact ? "mt-2" : "mt-2.5"}>
        <h3
          className={`font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors ${
            compact ? "text-sm" : "text-[15px]"
          }`}
        >
          {movie.title}
        </h3>
        {showActors ? (
          <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
            {movie.actors.slice(0, 2).join(" / ")}
          </p>
        ) : (
          <p className="mt-1 text-xs text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line" />
            {formatDate(movie.updatedAt)} 更新
          </p>
        )}
      </div>
    </Link>
  );
}